import React, { useState, useEffect } from "react";
import { Grid, useMediaQuery } from "@mui/material";
import UmTable from "./UmTable";
import SoftBox from "../../components/SoftBox";
// import InfoBar from "../../components/InfoBar";
import SoftTypography from "../../components/SoftTypography";
import PageHeader from "../../components/PageHeader";
import SoftButton from "../../components/SoftButton";
import CloseIcon from "@mui/icons-material/Close";
import { IS_REMINDER, SET_REMINDER } from "../../api/user";
import { UseUserDetails } from "../../hooks/auth";
import { useNavigate } from "react-router-dom";
import UnauthorizedPage from "../UnauthorizedPage";
import "./userManagementStyles.css";

const UserManagement = () => {
    const [isVisible, setIsVisible] = useState(false);
    const userDetails = UseUserDetails();
    const navigate = useNavigate();
    const lgBreakpoint = useMediaQuery((theme) => theme.breakpoints.up("lg"));

    useEffect(() => {
      const fetchReminder = async () => {
        try {
          const body = {
            companyId: userDetails.companyId,
          };
          const response = await IS_REMINDER(body);
          setIsVisible(response.data.isReminder);
          console.log('response.data', response.data);
        } catch (error) {
          console.error("Error fetching the award data:", error);
        }
      };
      fetchReminder();
    }, [userDetails.companyId]);

    const handleReminder = async () => {
      const body = {
        companyId: userDetails.companyId,
        setReminder: false,
      };
      await SET_REMINDER(body);
      setIsVisible(false);
    };

  if (!lgBreakpoint) {
    return <UnauthorizedPage forAdmin={false} />;
  }

  return (
    <>
      <PageHeader
        headerText="Players"
        subheaderText="Manage players in the workspace"
        onBack={() => navigate(-1)}
        inlineBack
      />
      {isVisible && 
        <SoftBox className={alert} sx={{padding: { mini: "0.5rem", xxs: "1.5rem 1.5rem 0rem 1.5rem",marginTop: "-2rem" }}}>
          <Grid container sx={{padding: "20px", background: "linear-gradient(273.63deg, #7928CA 0%, #FF0080 100%)", alignItems: "center", display: "flex", borderRadius: "8px" }}>
            <Grid item mini={10}>
                <SoftTypography sx={{ color: "#FFFFFF", fontSize: { mini: "18px", md: "16px" }, lineHeight: "24px", fontWeight: "500" }} variant="h3">
                  Welcome to Player Management. Add or remove players, This is a friendly reminder that any extra players will be charged $5 each in the upcoming billing cycle
                </SoftTypography>
            </Grid>
            <Grid item sx={{ display: 'flex', justifyContent: 'flex-end' }} mini={2}>
              <SoftButton
                variant="outlined"
                color="white"
                onClick={() => {
                  setIsVisible(false);
                  handleReminder();
                }}
                sx={{
                  "& svg": { fontSize: "1.25rem !important" },
                  borderRadius: "50%",
                  minWidth: "max-content",
                  minHeight: "max-content",
                  padding: "0.25rem",
                }}
              >
                <CloseIcon />
              </SoftButton>
            </Grid>
          </Grid>
          </SoftBox>
        }
      <SoftBox sx={{ margin: { mini: "1rem", sm: "1.5rem" } }}>
        <Grid container>
          <Grid item mini={12}>
            <UmTable />
          </Grid>
        </Grid>
      </SoftBox>
    </>
  );
};

export default UserManagement;
